const CONTENTFUL_SPACE_ID = 'pnq4hpds29uh';

export const contentfulEntryUrl = (id: string) =>
  `https://app.contentful.com/spaces/${CONTENTFUL_SPACE_ID}/entries/${id}`;
